
// Update these with your real business number.
export const PHONE_DISPLAY = '(805) 770-9317'
export const PHONE_HREF = 'tel:+18057709317'
export const SMS_HREF = 'sms:+18057709317'

